<template>
  <div>
    <multiselect
      v-model="selectedTravelers"
      @input="handleTravelers"
      :options="travelersList"
      :max="max"
      :preselect-first="false"
      :multiple="true"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :class="{ 'has-error': hasError }"
      track-by="name"
      label="name"
      placeholder="Selecione os viajantes*"
      selectedLabel="Selecionado"
      selectLabel="Clique para selecionar"
      deselectLabel="Clique para desmarcar seleção"
      name="selectedTravelers">
      <template
        slot="selection"
        slot-scope="{ values, search, isOpen }">
        <span
          class="form-control"
          v-if="values.length &amp;&amp; !isOpen">
          {{ values.length }} viajantes selecionados
        </span>
      </template>
      <template slot="maxElements">
        <span>
          Máximo de viajantes selecionados. Remova para selecionar outro.
        </span>
      </template>
    </multiselect>
    <div class="mt-5">
      <span
        v-if="!selectedTravelers.length"
        class="size-12 weight-normal">* Obrigatório selecionar os viajantes</span>
      <traveler-dialog class="pull-right"></traveler-dialog>
    </div>
    <div
      v-if="selectedTravelers.length"
      class="clearfix _pt-5">
      <div
        v-for="(traveler, index) in selectedTravelers"
        :key="`traveler-${index}`"
        class="col-xs-12 padding-off size-16 _pt-5 weight-normal clearfix">
        <template v-if="item">
          <span class="pull-left _pt-5">
            {{ traveler.name }} - {{ traveler.age_range | convertAgeRange }}
          </span>
        </template>
        <template v-else>
          <span class="pull-left _pt-5">
            {{ traveler.name }}
          </span>
        </template>
        <button
          @click.prevent="selectedTravelers.splice(index, 1)"
          class="btn-magenta-inverse pull-right">
          - Remover
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import convertAgeRange from '@/filters/convertAgeRange'
import Multiselect from 'vue-multiselect'
import TravelerDialog from '@/components/dialogs/TravelerDialog'

export default {
  filters: { convertAgeRange },
  components: {
    Multiselect,
    TravelerDialog
  },
  props: [
    'item',
    'max',
    'travelers',
    'error'
  ],
  data () {
    return {
      alert: null,
      selectedTravelers: []
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState('travelers', ['loading', 'results']),
    ...mapGetters('travelers', ['travelersByAgeRange']),
    hasError () {
      return this.error && !this.selectedTravelers.length
    },
    travelersList () {
      return (this.item) ? this.travelersByAgeRange(this.item) : this.results
    }
  },
  watch: {
    user (data) {
      if (data.completedRegister) {
        this.getTravelersParent()
      }
    }
  },
  mounted () {
    this.alert = null

    this.getTravelersParent()
      .catch(() => {
        this.alert = 'Não foi possível buscar os viajantes'
      })
  },
  methods: {
    ...mapActions('travelers', ['getTravelersParent']),
    handleTravelers (travelers) {
      this.$emit('update:travelers', travelers)
    }
  }
};
</script>

<style scoped lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';
@import '@/scss/components/forms/MultiselectField';
</style>
